module.exports = "images/get-inspired-10.jpg";